import React, { useState } from 'react';
import apiService from '../../../Common/Configurations/APIService';
import config from '../../../Common/Configurations/APIConfig';
import TemplateControls from '../../../template-library/TemplateControls';
import TemplatePreview from '../../../template-library/TemplatePreview';
import StyleBuilder from '../../../template-library/StyleBuilder';
import '../../../template-library/global-styles.css'

// Main styles for the two-pane layout
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: 'calc(100vh - 100px)', // Adjust height as needed, subtracting header/nav height
    borderTop: '1px solid #ddd',
  },
  controls: {
    width: '350px',
    padding: '20px',
    overflowY: 'auto',
    backgroundColor: '#f8f9fa',
    borderRight: '1px solid #ddd',
  },
  preview: {
    flex: 1, // Takes up the remaining space
    overflowY: 'auto',
    backgroundColor: '#fff',
  },
  
};

const availableComponents = {
    topBars: ['TopBar1', 'TopBar2', 'None'],
    headers: ['TemplateHeader1', 'TemplateHeader2', 'TemplateHeader3', 'TemplateHeaderHybrid','TemplateHeaderHybrid2'],
    heroes: ['TemplateHero1', 'TemplateHero2', 'TemplateHero3', 'TemplateHero4', 'TemplateHeroTabbedSearch','TemplateHeroTabbedSearch2'],
    
    destinations: ['Destinations1','Destinations2','Destinations3', 'None'],
    packages: ['FeaturedPackages1', 'FeaturedPackages2', 'None'],
    testimonials: ['Testimonials1','Testimonials2', 'None'],
    aboutUs: ['AboutUs1', 'None'],
    
    footers: ['TemplateFooter1', 'TemplateFooter2', 'TemplateFooter3'],
};

function CreateTemplate() {
  const [templateName, setTemplateName] = useState('');
  const [description, setDescription] = useState('');
  const [thumbnail, setThumbnail] = useState(null);
  const [layout, setLayout] = useState({
    topBar: 'TopBar1',
    header: 'TemplateHeader1',
    hero: 'TemplateHero1',
    destinations: 'None',                  // Default to not showing this section
    packages: 'FeaturedPackages1',
    testimonials: 'None',
    aboutUs: 'None',
    footer: 'TemplateFooter1',
  });

  // --- THIS IS THE NEW STATE FOR STYLES ---
  const [styleConfig, setStyleConfig] = useState({
    primary: "#007bff",
    secondary: "#6c757d",
     topBar: {
      bgColor: "#f8f9fa",
      textColor: "#212529"
    },
    header: {
      bgColor: "#007bff",
      linkColor: "#ffffff",
      textColor: "#ffffff"
    },
    hero: {
      overlayColor: "rgba(0, 0, 0, 0.4)",
      subtitleColor: "#e9ecef" 
    }
    ,
    footer: {
      bgColor: "#2c3e50",
      textColor: "#ecf0f1",
      linkColor: "#bdc3c7"
    }
  });

  const [btnLoading, setBtnLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!templateName || !thumbnail) {
      alert("Template Name and Thumbnail are required.");
      return;
    }
    setBtnLoading(true);

    try {
      // --- NEW, SIMPLER FORMDATA ---
      const formData = new FormData();
      formData.append('Name', templateName);
      formData.append('Description', description);
      formData.append('LayoutJson', JSON.stringify(layout));
      formData.append('StyleJson', JSON.stringify(styleConfig)); // <-- Send StyleJson
      formData.append('Thumbnail', thumbnail);
      
      await apiService.postWithFile(config.CREATETEMPLATE, formData, true);
      
    } catch (error) {
      console.error("Failed to create template:", error);
    } finally {
      setBtnLoading(false);
    }
  };

return (
    <div>
      <div style={{ padding: '15px 20px', backgroundColor: '#fff', borderBottom: '1px solid #ddd' }}>
        <h2>Create New Website Template</h2>
      </div>
      <div style={styles.container}>
        <div style={styles.controls}>
          <TemplateControls
            templateName={templateName}
            setTemplateName={setTemplateName}
            description={description}
            setDescription={setDescription}
            setThumbnail={setThumbnail}
            layout={layout}
            setLayout={setLayout}
            btnLoading={btnLoading}
            handleSubmit={handleSubmit}
            availableComponents={availableComponents}
            // Pass the new style state and handler down
            styleConfig={styleConfig}
            setStyleConfig={setStyleConfig}
          />
        </div>
        <div style={styles.preview}>
          <TemplatePreview layout={layout} styleConfig={styleConfig} />
        </div>
      </div>
    </div>
  );
}

export default CreateTemplate;